import { on } from "ts-action-immer";
import { reducer } from "ts-action";
import { StateReducerProps } from "../types";
import { statePLACEHOLDER } from "../placeholderData";
import {
  isDataSourceStateFetching,
  updateDataSourceState,
} from "../actionCreators";

const initialState: StateReducerProps = {
  data: statePLACEHOLDER,
  isFetching: false,
};

const dataSourceStateReducer = reducer(
  initialState,
  on(updateDataSourceState, (state, { payload: { dataSourceState } }) => {
    // eslint-disable-next-line no-param-reassign
    state.data = dataSourceState;
  }),
  on(isDataSourceStateFetching, (state, { payload: { flag } }) => {
    // eslint-disable-next-line no-param-reassign
    state.isFetching = flag;
  })
);

export default dataSourceStateReducer;
